import {Component, Module} from 'app/decorators';
import tpl from './formula.html';


@Module({
    name: "app.tickets.component.formulation",

})
@Component({
    selector: 'blnd-formula',
    bindings: {
        ticket: '=',
    },
    template: tpl,
})
export default class C {
    constructor($element) {
        "ngInject";
        this.$element = $element;
    }

    $onDestroy () {
        this.$element.remove();
        this.$element = null;
    }

}



// WEBPACK FOOTER //
// ./src/app/tickets/components/formula.js